const BREAKPOINT = 750;
const DEBOUNCE_MS = 150;

function debounce(fn, wait) {
  let timeoutId;
  return function debounced(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), wait);
  };
}

class ResponsiveMedia extends HTMLElement {
  connectedCallback() {
    this._desktop = this.querySelector('.media-desktop');
    this._mobile = this.querySelector('.media-mobile');
    this._syncRafId = null;
    this._onResize = debounce(() => this._update(), DEBOUNCE_MS);
    window.addEventListener('resize', this._onResize);
    this._update();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);

    if (this._syncRafId !== null) {
      cancelAnimationFrame(this._syncRafId);
      this._syncRafId = null;
    }
  }

  _isBranchVisible(branch) {
    return !!(branch && !branch.hidden);
  }

  _pauseVideos(root) {
    if (!root) return;

    root.querySelectorAll('video').forEach((video) => {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (_) {}
    });
  }

  _playVideos(root) {
    if (!root || !this._isBranchVisible(root)) return;

    root.querySelectorAll('video').forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      video.play().catch(() => {});
    });
  }

  _shouldAutoplay() {
    const slide = this.closest('[data-slide]');

    if (!slide) return true;

    return slide.classList.contains('is-selected');
  }

  _dispatchUpdate() {
    this.dispatchEvent(new CustomEvent('responsive-media:update', { bubbles: true }));
  }

  _syncVideos() {
    this._pauseVideos(this._desktop);
    this._pauseVideos(this._mobile);

    if (this._syncRafId !== null) {
      cancelAnimationFrame(this._syncRafId);
      this._syncRafId = null;
    }

    if (!this._shouldAutoplay()) {
      this._dispatchUpdate();
      return;
    }

    const isMobile = window.innerWidth < BREAKPOINT;
    const visible = isMobile ? this._mobile : this._desktop;

    this._syncRafId = requestAnimationFrame(() => {
      this._syncRafId = null;
      this._playVideos(visible);
      this._dispatchUpdate();
    });
  }

  _update() {
    if (!this._desktop || !this._mobile) return;

    const isMobile = window.innerWidth < BREAKPOINT;
    this._desktop.hidden = isMobile;
    this._mobile.hidden = !isMobile;

    this._syncVideos();
  }
}

if (!customElements.get('responsive-media')) {
  customElements.define('responsive-media', ResponsiveMedia);
}